import React                              from 'react';
import { Observe }                        from 'rewire-core';
import {
  WithStyle,
  withStyles,
  FormView,
}                                         from 'rewire-ui';
import { Theme }                          from '@material-ui/core/styles';
import DraggableResizableDialog           from '../ui/DraggableResizableDialog';
import duplicateMultipleShiftsDialogModel from './DuplicateMultipleShiftsDialogModel';

const styles = (_theme: Theme) => ({
});

interface IDuplicateMultipleShiftsDialogProps {
}

type DuplicateMultipleShiftsDialogProps = WithStyle<ReturnType<typeof styles>, IDuplicateMultipleShiftsDialogProps>;

class DuplicateMultipleShiftsDialog extends React.PureComponent<DuplicateMultipleShiftsDialogProps> {
  constructor(props: DuplicateMultipleShiftsDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    duplicateMultipleShiftsDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => {
      return (
        <FormView form={duplicateMultipleShiftsDialogModel.form} onSubmit={duplicateMultipleShiftsDialogModel.actionFn('save')}>
          {duplicateMultipleShiftsDialogModel.form.fields.map((field: any) =>
            <div key={field.name} className='content'>
              <field.Editor className='span1' />
            </div>
          )}
        </FormView>
      );
    }} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: duplicateMultipleShiftsDialogModel}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '200px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IDuplicateMultipleShiftsDialogProps,unknown>(styles, DuplicateMultipleShiftsDialog);
